import { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { captureAnalytics } from '../../../actions/preload';

/* global toastr */

const CHARGEBEE_SRC = 'https://js.chargebee.com/v2/chargebee.js';
let chargebeeLoad = null;

// Chargebee (~280KB) is only needed for this modal, so it loads on first open
// instead of blocking the first render of every page from the layout <head>.
export const loadChargebee = () => {
  if (window.Chargebee) return Promise.resolve(window.Chargebee);
  if (!chargebeeLoad) {
    chargebeeLoad = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = CHARGEBEE_SRC;
      script.async = true;
      const fail = () => {
        chargebeeLoad = null;
        script.remove();
        reject(new Error('Chargebee failed to load'));
      };
      // A script that loads but errors while executing still fires `load`; treat a
      // missing SDK global as a failure so the next open retries.
      script.onload = () => (window.Chargebee ? resolve(window.Chargebee) : fail());
      script.onerror = fail;
      document.head.appendChild(script);
    });
  }
  return chargebeeLoad;
};

class UpdatePaymentMethod extends Component {
  componentDidMount() {
    this.mounted = true;
    captureAnalytics('billing_payment_method_dialog_opened');
    loadChargebee().then((Chargebee) => {
      if (!this.mounted) return;
      Chargebee.init({
        site: process.env.CB_SITE,
        publishableKey: process.env.CB_KEY,
      });
      this.updatePaymentDetails(Chargebee.getInstance());
    }).catch(() => {
      if (!this.mounted) return;
      captureAnalytics('billing_payment_method_dialog_load_failed');
      toastr.error('Unable to open payment settings. Please try again.');
      this.props.closeModal();
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  updatePaymentDetails = (cbInstance) => {
    const { closeModal } = this.props;
    cbInstance.openCheckout({
      hostedPage: async () => {
        return axios.get(`${window.location.origin}/api/v1/payments/update_payment_method`).then((response) => response.data);
      },
      close: () => {
        closeModal();
      },
    });
  };

  render() {
    return null;
  }
}

UpdatePaymentMethod.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default UpdatePaymentMethod;
